// ----------------------------------------------------------------------
// <copyright file='Izenda.SubscribeReportButton.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var Link = require('react-router').Link;
  var Button = require('share/components/controls/Izenda.Button');
  var SubscriptionPopup = require('modules/Subscription/Izenda.SubscriptionPopup');
  var ReportSubscriptionConstants = require('logic/data/Izenda.ReportSubscriptionConstants');
  var PopupInput = require('share/components/controls/Izenda.PopupInput');
  var SubscriptionGrid = require('modules/Subscription/Izenda.SubscriptionGrid');
  var REPORT_DESIGNER_CONSTANST = require('logic/data/Izenda.ReportDesignerConstants');
  var connect = require('share/enhancers/Izenda.Connect');

  var observer = require('mobx-react').observer;
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var classnames = require('classnames');
  const { find } = require('lodash/fp');

  var SubscribeReportButton = React.createClass({
    propTypes: {
      reportId: React.PropTypes.string.isRequired,
      reportType: React.PropTypes.string.isRequired,
      store: React.PropTypes.object.isRequired
    },

    render: function() {
      var props = this.props;
      var localization = props.localization;
      var store = props.store;
      var reportId = props.reportId;
      var reportType = props.reportType;

      var popupTitle = this.getPopupTitle(reportType);

      return (
        <div className="report-subscription btn-group floatNone u_marginLeft">
          <PopupInput
            className="btn btn-primary"
            label={localization.getText('COMMON_LABEL_SUBSCRIBE')}
            onChange={this.onChange}
            popupProps={{
              type: 'none',
              autoClose: false,
              sizeClass: 'modal-lg',
              showSubscriptionPopup: this.props.showSubscriptionPopup,
              emailTemplates: store.model.emailTemplates
            }}
            popupContentProps={{
              confirmButtonLabel: localization.getText('COMMON_LABEL_SAVE'),
              beforeClosing: 'beforeClosing',
              showSubscriptionPopup: this.props.showSubscriptionPopup,
              emailTemplates: store.model.emailTemplates
            }}
            popupTitle={popupTitle}
            popupContent={SubscriptionGrid}
            store={store}
            onClick={this.onClick}
            pageConstants={ReportSubscriptionConstants}
            onSavePopupDesigner={this.onSaveSubscription}
            isPopupMode
            disabled={props.disabled}
          />
        </div>
      );
    },

    /**
     * Save subscription data.
     */
    onSaveSubscription: function(subData) {
      this.props.store.model.updateSubscribedInstances(subData);
    },

    /**
     * Handle action when get value
     * @return {object}
     */
    onChange: function(value) {
      var store = this.props.store;
      store && store.saveInstances();
    },

    /**
     * Load data when open popup
     * @return {object}  Promise
     */
    onClick: function() {
      var store = this.props.store;
      store && store.updateReportId(this.props.reportId);
      return store && store.loadInstances();
    },

    getPopupTitle: function(reportType) {
      var reportTypes = REPORT_DESIGNER_CONSTANST.TYPES;
      var localization = this.props.localization;
      var reportTypeDefine =
        find(
          function(item) {
            return item.id === parseInt(reportType, 10);
          }.bind(this),
          reportTypes
        ) || {};

      var reportTypeName = reportTypeDefine.value || '';
      return String.format(localization.getText('REPORT_LABEL_NUMBER_OF_SUBSCRIPTION'), reportTypeName);
    }
  });

  module.exports = connect()(SubscribeReportButton);
})();



// WEBPACK FOOTER //
// ./ui/modules/Reports/Buttons/Izenda.SubscribeReportButton.jsx